import { FC, useRef, useState } from 'react';

import cn from 'clsx';
import ColorThief from 'colorthief';
import edu_ic from '@images/scroll.png';
import './HeaderImage.css';
import PollPledgeIcon from '@components/modules/Poll/PollPledgeIcon';

export type Props = {
  title?: string;
  mightyTitle?: boolean;
  titleSize?: number;
  image?: string;
  alt?: string;
  pledge?: boolean;
  edu?: boolean;
};

const HeaderImage: FC<Props> = ({
  title,
  mightyTitle,
  image,
  alt,
  pledge = false,
  edu = false,
}) => {
  const [bgColor, setBgColor] = useState<string>('#221f20');
  const imgRef = useRef<HTMLImageElement>(null);
  const titleLen = title?.length || 0;
  const titleCn = cn(
    'overflow-ellipsis overflow-hidden absolute bottom-4 align-bottom px-4 text-white z-10 max-h-1/2 w-full break-all flex flex-row font-bold',
    {
      'text-4xl': titleLen <= 20,
      'text-3xl': titleLen <= 30,
      'text-2xl': titleLen <= 80,
    }
  );
  if (!image) return <div>{title && <h1 className={titleCn}>{title}</h1>}</div>;

  return (
    <div
      className="transition duration-300 ease-in-out headerimage relative"
      style={{ backgroundColor: bgColor }}
    >
      <img
        ref={imgRef}
        src={image}
        alt={alt}
        crossOrigin="anonymous"
        onLoad={async () => {
          if (imgRef?.current) {
            const colorthief = new ColorThief();
            const color = colorthief.getColor(imgRef?.current);
            if (color) {
              setBgColor(`rgb(${color[0]},${color[1]},${color[2]})`);
            }
          }
        }}
      />

      {title && (
        <div className="container mx-auto">
          <div className={titleCn}>{title}</div>
        </div>
      )}

      {pledge && (
        <div
          className="absolute z-50 w-12 h-12 lg:w-24 lg:h-24 bottom-0"
          style={{ right: 20 }}
        >
          <div className="relative" style={{ width: '100%', height: '100%' }}>
            {edu && (
              <img
                src={edu_ic}
                alt=""
                className="w-12 h-12 lg:w-30 lg:h-30"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  transform: 'translate(-110%,10%)',
                }}
              />
            )}
            <PollPledgeIcon color="animated" />
          </div>
        </div>
      )}
      <div className="fadeBottom" />
    </div>
  );
};

export default HeaderImage;
